import api from "@/shared/services/apiClient";
import type { Assessment, AssessmentFormData, AttemptResult } from "../types/assessment";

export const assessmentService = {
  list: (): Promise<Assessment[]> =>
    api.get("/assessments").then((r) => r.data),

  get: (id: string): Promise<Assessment> =>
    api.get(`/assessments/${id}`).then((r) => r.data),

  create: (data: AssessmentFormData): Promise<Assessment> =>
    api.post("/assessments", data).then((r) => r.data),

  update: (id: string, data: Partial<AssessmentFormData>): Promise<Assessment> =>
    api.patch(`/assessments/${id}`, data).then((r) => r.data),

  delete: (id: string): Promise<void> =>
    api.delete(`/assessments/${id}`).then(() => undefined),

  togglePublish: (id: string): Promise<Assessment> =>
    api.patch(`/assessments/${id}/publish`).then((r) => r.data),

  importQuestions: (id: string, questions: AssessmentFormData["questions"]): Promise<Assessment> =>
    api.post(`/assessments/${id}/import`, { questions }).then((r) => r.data),

  getResults: (id: string, filters?: Record<string, string>): Promise<AttemptResult[]> =>
    api.get(`/assessments/${id}/results`, { params: filters }).then((r) => r.data),
};
